import { mdxComponents } from "@/ui/mdx-components";
import { longDateFormat } from "@/utils/date";

export interface LegalFrontmatter {
  effective: string;
  title: string;
  updated: string;
}

interface FrontmatterProps {
  frontmatter: LegalFrontmatter;
}

// Present the title and version dates consistently across the legal documents.
export function Frontmatter({ frontmatter }: FrontmatterProps) {
  const wasUpdated = frontmatter.effective !== frontmatter.updated;

  return (
    <>
      <mdxComponents.h1>{frontmatter.title}</mdxComponents.h1>
      <mdxComponents.p className="text-muted-foreground text-sm">
        Effective {longDateFormat(frontmatter.effective)}
        {wasUpdated && (
          <> · Last updated {longDateFormat(frontmatter.updated)}</>
        )}
      </mdxComponents.p>
    </>
  );
}

// Render optional operator contact fields only after verified deployment
// values are configured.
export function LegalContactDetails() {
  if (!publicEnv.siteLegalMailingAddress && !publicEnv.siteLegalPhone) {
    return null;
  }

  return (
    <div>
      {publicEnv.siteLegalMailingAddress && (
        <mdxComponents.p>
          Mailing address: {publicEnv.siteLegalMailingAddress}
        </mdxComponents.p>
      )}
      {publicEnv.siteLegalPhone && (
        <mdxComponents.p>Telephone: {publicEnv.siteLegalPhone}</mdxComponents.p>
      )}
    </div>
  );
}
